// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2l-iH","inputSuccess":"FieldCurrencyInput_inputSuccess__1ZVE8","inputError":"FieldCurrencyInput_inputError__3cgyB"};